import script from "./ajSearchHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ajSearchHeader.vue?vue&type=script&setup=true&lang=js"

import "./ajSearchHeader.vue?vue&type=style&index=0&id=1999cf44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1999cf44"]])

export default __exports__